<style lang="scss" scoped>
.footer-container {
    padding: 10px 15px;
    border-top: 1px solid #ebebeb;
}
</style>
<template>
    <div>
        <Form
            class="clearfix margin-top-15"
            ref="addForm"
            :labelWidth="120"
            :model="formData"
        >
            <Col span="12" style="height: 43px">
                <FormItem
                    label="销毁计划单号"
                    prop="destroyPlanOrderNo"
                    :rules="required"
                >
                    <vInput
                        v-model="formData.destroyPlanOrderNo"
                        readonly
                        suffix="search"
                        @on-icon-click="handleOrderNo"
                    ></vInput>
                </FormItem>
            </Col>
            <Col span="12" style="height: 43px">
                <FormItem label="来源单号">
                    <Input v-model="formData.sourceNo"></Input>
                </FormItem>
            </Col>
            <Col span="12" style="height: 43px">
                <FormItem label="销毁仓库">
                    <div class="font-weight">
                        {{ formData.orgWarehouseName }}
                    </div>
                </FormItem>
            </Col>
            <Col span="12" style="height: 43px">
                <FormItem label="项目">
                    <div class="font-weight">{{ formData.lineName }}</div>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem label="备注">
                    <Input type="textarea" v-model="formData.remark"></Input>
                </FormItem>
            </Col>
        </Form>
        <footer class="footer-container clearfix">
            <div class="pull-right">
                <Button class="margin-right-15" type="primary" @click="next"
                    >下一步</Button
                >
                <Button @click="$emit('on-close')">取消</Button>
            </div>
        </footer>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
            @on-confirm="modalProps.show = false"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                @on-close="modalProps.show = false"
                @on-success="modalSuccess"
                v-on="modalProps.on"
            />
        </compModal>
        <Spin v-if="loading" fix size="large"></Spin>
    </div>
</template>
<script>
import compPlan from "./destoryPlan.js";
import { HttpCreateDestoryOrder } from "@/service/destory";
export default {
    components: {
        compPlan,
    },
    data() {
        return {
            formData: {},
            required: {
                required: true,
                message: "请填写必填项",
            },
            modalProps: {
                show: false,
                formdata: null,
            },
            loading: false,
        };
    },
    methods: {
        handleOrderNo() {
            this.modalProps = {
                show: true,
                title: "查找销毁计划单",
                component: "compPlan",
                showFooter: false,
                width: 1000,
                // props: {
                //     // initFormData: {
                //     //     "search[EQ_inventoryType]": this.baseInfo.inventoryType,
                //     //     "search[EQ_orgWarehouseId]":
                //     //         this.orgWarehouseId == 0
                //     //             ? ""
                //     //             : this.baseInfo.orgWarehouseId,
                //     //     lineId: this.baseInfo.lineId,
                //     //     "search[EQ_organizationId]": global.SYSID,
                //     // },
                // },
                on: {
                    "on-data": (row) => {
                        console.log(row);
                        this.formData = {
                            id: "",
                            ...row,
                            sourceNo: this.formData.sourceNo,
                            remark: this.formData.remark,
                            destroyPlanOrderId: row.id,
                        };
                        this.modalProps.show = false;
                    },
                },
            };
        },
        async next() {
            let flag = true;
            await this.$refs.addForm.validate((valid) => {
                return (flag = valid);
            });
            if (!flag) return;
            this.loading = true;
            let { id, ...reqData } = {...this.formData}
            HttpCreateDestoryOrder({
                ...reqData
            }).then(
                (res) => {
                    console.log(res)
                    this.$router.push({
                        name: "destoryOrderUpdate",
                        params: { type: "edit" },
                        query: { id: res.data.id },
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message)
                }
            );
        },
    },
};
</script>

<style>
</style>